<template>
  <div>
    <header id="Header">
      <Cookies />
      <Header />
      <Menu :rotas="routesComputed" />
    </header>
    <main id="main">
      <router-view></router-view>
    </main>
    <Footer :rotas="routesComputed" />
  </div>
</template>

<script>
import Vue from "vue";
import VueI18n from "vue-i18n";

import { routes } from "./routes";
import Header from "./components/shared/Header.vue";
import Footer from "./components/shared/Footer.vue";
import Menu from "./components/shared/Menu.vue";
import Cookies from './components/Cookies/Cookies.vue'
import siteMapService from "./domain/siteMapService";

export default {
  components: {
    Header,
    Footer,
    Menu,
    Cookies,
  },
  watch: {
    "$i18n.locale": function () {
      localStorage.setItem("locale", this.$i18n.locale);
    },
  },
  methods: {
    createJsonSiteMap() {
      this.urlsMap = [];
      const _routes = routes(this.$i18n.messages[this.$i18n.locale]);
      for (let obj in _routes) {
        if (_routes[obj].menu) {
          this.urlsMap.push({
            endpoint: `${_routes[obj].path}`,
          });
        }
      }
      this.service(this.urlsMap);
    },

    service(obj) {
      this.serviceMap = new siteMapService(this.$resource);

      this.serviceMap.sendMap(obj).then((res) => {
        this.map = res;
        return this.map;
      });
    },
  },

  created() {
    this.createJsonSiteMap();
  },
  computed: {
    routesComputed: function () {
      return routes(this.$i18n.messages[this.$i18n.locale]).filter(
        (route) => route.menu
      );
    },
  },
};
</script>

<style lang="scss">
@import "./assets/scss/Style.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue